import React, { useState } from 'react';
import { Button, Tooltip, makeStyles, shorthands } from '@fluentui/react-components';
import { ReactComponent as DeleteIcon } from '../../../../assets/Trash.svg';
import { customColors } from '../../../../styles';
import ConfirmDialog from '../../../../shared/ui/ConfirmDialog';

const useStyles = makeStyles({
    triggerButton: {
        color: customColors.white,
        backgroundColor: 'transparent',
        ...shorthands.border('none'),
        minWidth: 'unset',
        '& svg path': {
            fill: 'currentColor',
        },
        ':hover': {
            backgroundColor: 'transparent',
            color: customColors.headerLightGray,
        },
        ':active': {
            backgroundColor: 'transparent',
            color: customColors.headerLightGray,
        },
    },
});

interface DeleteChatDialogProps {
    chatName: string;
    onDelete: () => Promise<void>;
}

export const DeleteChatDialog: React.FC<DeleteChatDialogProps> = ({ chatName, onDelete }) => {
    const styles = useStyles();
    const [open, setOpen] = useState(false);

    return (
        <>
            <Tooltip content={'Delete chat session'} relationship="label">
                <Button
                    className={styles.triggerButton}
                    appearance="transparent"
                    aria-label="delete_chat"
                    icon={<DeleteIcon />}
                    onClick={() => setOpen(true)}
                />
            </Tooltip>
            <ConfirmDialog
                open={open}
                message={`Are you sure you want to delete chat ${chatName}?`}
                onConfirm={() => {
                    setOpen(false);
                    void onDelete();
                }}
                onCancel={() => setOpen(false)}
            />
        </>
    );
};

export default DeleteChatDialog;
